class SassListing extends HTMLElement {
  constructor() {
    super();
    this.productItem = this.querySelectorAll(".sass-item");
    this.addToCart = document.querySelector(".sass-checkout");
    this.variantButton = this.querySelector(".variant-slider button");
    this.footer = document.querySelector(".sass-footer");
    this.gifts = document.querySelectorAll(".page-sass__gifts-product");

    const resizeObserver = new ResizeObserver((entries) => this.resize());
    resizeObserver.observe(this);
    this.addListeners();
  }

  resize() {
    if (window.innerWidth >= 768) {
      this.querySelector(".sass-item").classList.remove("checked");
      this.querySelector(".sass-item").classList.add("checked");
    }
  }

  addListeners() {
    this.addToCart.addEventListener("click", (e) => this.onAddToCart(e));
    window.addEventListener(
      "onProductSelected",
      (e) => this.updateFooter(e),
      false
    );
    this.productItem[0].click();
  }

  async onAddToCart(e) {
    e.preventDefault();

    var selectedProduct = this.querySelector(".sass-item.checked");

    var handle = selectedProduct.getAttribute("data-handle");

    const paywhirlAvailable = selectedProduct.querySelectorAll(
      ".paywhirl-group-available"
    );

    if (paywhirlAvailable.length > 1) {
      paywhirlAvailable[0].classList.remove("paywhirl-group-selected");
      paywhirlAvailable[1].classList.add("paywhirl-group-selected");
    }

    const data = [
      {
        id: selectedProduct.getAttribute("data-product-id"),
        quantity: 1,
        selling_plan: selectedProduct.querySelector('[name="selling_plan"]')
          .value,
        properties: {
          "_product-discount":
            selectedProduct.querySelector('[name="discount"]').value,
          _pricebook: selectedProduct.querySelector('[name="_pricebook"]')
            .value,
        },
      },
    ];

    // Empty cart before adding new item
    await postData(`${routes.cart_clear_url}.js`);

    // Get gifts products
    this.gifts.forEach((gift) => {
      if (gift.getAttribute("data-product-id") !== null) {
        data.push({
          id: gift.getAttribute("data-product-id"),
          quantity: 1,
          selling_plan: gift.querySelector('[name="selling_plan"]').value,
          properties: {
            _pricebook: selectedProduct.querySelector('[name="_pricebook"]')
              .value,
          },
        });
      }
    });

    postData(`${routes.cart_add_url}.js`, { items: data })
      .then((response) => {
        if (selectedProduct.getAttribute("data-upsell") != "") {
          window.location = selectedProduct.getAttribute("data-upsell");
        } else {
          window.location = `/checkout?${(Math.random() + 1)
            .toString(36)
            .substring(2)}`;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  onVariantSelected(e) {
    e.preventDefault();
    const $target = e.currentTarget;
    this.productItem.forEach((element) =>
      element.dispatchEvent(
        new CustomEvent("variant:changed", [$target.getAttribute("index")])
      )
    );
  }

  updateFooter(e) {
    this.footer.querySelector(".sass-footer-title").innerHTML = e.detail.title;
    this.footer.querySelector(".sass-footer-price").innerHTML = e.detail.price;
    this.footer.querySelector(".sass-footer-image").src = e.detail.image;
  }

  getSelectedProducts = (items) =>
    Array.from(items).map((item) => ({
      id: item.getAttribute("data-product-id"),
      quantity: 1,
    }));
}

async function postData(url = "", data = {}) {
  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];
  // Default options are marked with *
  const response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    body: JSON.stringify(data), // body data type must match "Content-Type" header
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.json(); // parses JSON response into native JavaScript objects
}

customElements.define("sass-listing", SassListing);

class SassSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    if (this.getAttribute("data-slider-enabled-mobile") === "false") {
      return;
    }
    this.config = JSON.parse(this.getAttribute("data-slider-config"));
    if (!this.slider || typeof $.fn.slick === "undefined") {
      console.warn("No slider found");
      return;
    }
    $(this.slider).not(".slick-initialized").slick(this.config);
    this.mobile = this.desktop = false;
    this.onResize();
    $(this.slider).on("breakpoint", () => this.onResize());
    $(this.slider).on("beforeChange", (event, slick, currentSlide, nextSlide) =>
      this.querySelector(
        `sass-product[data-slick-index="${nextSlide}"]`
      ).click()
    );
  }

  onResize() {
    const width = window.innerWidth;

    if (width < 640 && !this.mobile) {
      this.mobile = true;
      this.desktop = false;
      $(".page-sass__product").removeClass("disable-selection");
      $(this.slider).slick("slickUnfilter");
      $(this.slider).slick(
        "slickFilter",
        ".page-sass__product--mobile-only, .page-sass__product--both"
      );

      const mobileItems = $(".page-sass__product").filter(
        ".page-sass__product--mobile-only, .page-sass__product--both"
      );

      this.checkItemsSelection(mobileItems);

      const dots = $(this.slider).find(".slick-dots");
      if (dots.find("li").length > 1) {
        dots.show();
      } else {
        dots.hide();
      }
    } else if (width >= 640 && !this.desktop) {
      this.mobile = false;
      this.desktop = true;
      $(".page-sass__product").removeClass("disable-selection");

      $(this.slider).slick("slickUnfilter");
      $(this.slider).slick(
        "slickFilter",
        ".page-sass__product--desktop-only, .page-sass__product--both"
      );

      const desktopItems = $(".page-sass__product").filter(
        ".page-sass__product--desktop-only, .page-sass__product--both"
      );

      this.checkItemsSelection(desktopItems);
    }
  }

  checkItemsSelection(items) {
    if (items.filter(".checked").length == 0) {
      items.first().click();
    } else if (items.filter(".checked").length > 1) {
      items.first().removeClass("checked");
    }
    if (items.length == 1) {
      items.first().addClass("disable-selection");
    }
  }
}
customElements.define("sass-slider-component", SassSliderComponent);

function throttle(f, delay) {
  let timer = 0;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => f.apply(this, args), delay);
  };
}
